import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { Role, DynamicFieldModel, Option, AppMenuService, MenuItem, DynamicFormComponent } from '@share';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { RoleService } from '../role/role.service';
import { AdminUserService } from './admin-user.service';
import { HttpParams } from '@angular/common/http';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { forkJoin } from 'rxjs';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';

@Component({
  selector: 'app-admin-user',
  imports: [DynamicTableComponent, CommonModule],
  templateUrl: './admin-user.component.html',
  styleUrl: './admin-user.component.scss'
})
export class AdminUserComponent {
  roleOption: Option[] = [];
  total = 0;
  pageSize = 10;
  pageIndex = 1;
  searchValue = '';
  list: any = [];

  schema = {
    name: "Admin List",
    permissionKey: "admin",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "small",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "name",
        title: "Name",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "roles_names",
        title: "Roles",
        type: "string_arr",
        enableSearch: true,
        searchType: "select",
        width: "200px",
        option: [] as any[],
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };


  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Role Name required',
        },
      ],
    },
    {
      label: 'Email',
      name: 'email',
      type: 'input',
      placeholder: '',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Email Name required',
        },
        ,
        {
          name: 'email',
          validator: Validators.email,
          message: 'Email Invalid',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    {
      label: 'Roles',
      name: 'roles_ids',
      type: 'select',
      multiple: true,
      value: [],
      placeholder: 'Select Roles',
      options: [
      ],
      class: 'col-md-6',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Roles required',
        },
      ],
    },


  ];
  width: string;
  tableHeight: string
  constructor(private readonly adminUserService: AdminUserService, private readonly loadingService: LoadingService, private readonly modalService: NzModalService, private readonly appMenuService: AppMenuService, private readonly roleService: RoleService, private readonly fb: FormBuilder, private readonly cdr: ChangeDetectorRef) {

  }


  ngOnInit(): void {
    this.calculateWidth();
    let params = new HttpParams()
      .set('page', this.schema.pageIndex.toString())
      .set('pageSize', this.schema.pageSize.toString());
    this.loadData(params);
  }

  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }

  ngAfterViewInit(): void {
  }

  loadData(params: HttpParams) {
    this.loadingService.toggleTableLoading();
    forkJoin({
      admin: this.adminUserService.getAdminUsers(params),
      role: this.roleService.getRoles(null) // Add more API calls here if needed
    })
      .subscribe({
        next: ({ admin, role }) => {
          this.list = admin.data;
          this.total = admin.totalCount;
          // Process roles
          this.roleOption = role.roles.map((y: any) => ({
            value: y?.id,
            text: y?.name
          }));
          this.fieldConfig[3].options = this.roleOption;

          this.schema.columns[2].option = role.roles.map((y: any) => ({
            value: y?.name,
            text: y?.name
          }));

        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => {
          this.loadingService.toggleTableLoading();
          this.cdr.detectChanges();
        }
      })

  }
  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  formEvent(data: any) {
    if (data.id) {
      data.roles = data.roles_ids;
      this.adminUserService.updateAdminUser(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.adminUserService.deleteAdminUser(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {

        }
      });

    }
    else {
      this.adminUserService.createAdminUser(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
